import axios from 'src/app-axios';
import axiosPublic from 'axios';
import { backendUrl } from 'src/app-globals';
import Constants from 'src/constants';

export const projects = {
  namespaced: true,
  state: {
    projectBudgets: [],
    projectIssues: [],
    budgetInstances: [],
    projectContracts: [],
    organizationProjects: [],
    selectedOrgProject: {},
    organizationProjectGates: [],
    selectedOrgProjectGate: {},
    projectAppUserActivities: [],
    gateDetails: {},
    orgDetails: {},
    projectCompanies: [],
  },
  getters: {
    getProjectBudgets (state) {
      return state.projectBudgets;
    },
    getProjectIssues (state) {
      return state.projectIssues;
    },
    getBudgetInstances (state) {
      return state.budgetInstances;
    },
    getProjectContracts (state) {
      return state.projectContracts;
    },
    getOrganizationProjects (state) {
      return state.organizationProjects;
    },
    getSelectedOrgProject (state) {
      return state.selectedOrgProject;
    },
    getOrganizationProjectGates (state) {
      return state.organizationProjectGates;
    },
    getSelectedOrgProjectGate (state) {
      return state.selectedOrgProjectGate;
    },
    getAppUserProjectActivities (state) {
      return state.projectAppUserActivities;
    },
    getGateDetails (state) {
      return state.gateDetails;
    },
    getOrgDetails (state) {
      return state.orgDetails;
    },
    getProjectCompanies (state) {
      return state.projectCompanies;
    },
  },
  mutations: {
    setProjectBudgets (state, budgets) {
      state.projectBudgets = budgets;
    },
    setProjectIssues (state, issues) {
      state.projectIssues = issues;
    },
    setBudgetInstances (state, instances) {
      state.budgetInstances = instances;
    },
    setProjectContracts (state, contracts) {
      state.projectContracts = contracts;
    },
    setOrganizationProjects (state, projects) {
      state.organizationProjects = projects;
    },
    setSelectedOrgProject (state, selectedOrgProject) {
      state.selectedOrgProject = selectedOrgProject;
    },
    setOrganizationProjectGates (state, projectGates) {
      state.organizationProjectGates = projectGates;
    },
    setSelectedOrgProjectGate (state, selectedOrgProjectGate) {
      state.selectedOrgProjectGate = selectedOrgProjectGate;
    },
    setAppUserProjectActivities (state, activities) {
      state.projectAppUserActivities = [
        ...state.projectAppUserActivities,
        ...activities.data,
      ];
    },
    setGateDetails (state, data) {
      state.gateDetails = data;
    },
    clearAppUserProjectActivitiesData (state) {
      state.projectAppUserActivities = [];
    },
    setOrgDetails (state, details) {
      state.orgDetails = details;
    },
    setProjectCompanies (state, details) {
      state.projectCompanies = details;
    },
  },
  actions: {
    async fetchProjectBudgets ({ dispatch, commit }, payload) {
      const url = `api/devices/projects/${payload.projectId}/budgets`;
      try {
        const budgets = await axios.get(url);
        commit('setProjectBudgets', budgets.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the project budgets list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchProjectIssues ({ dispatch, commit }, payload) {
      const url = `api/devices/projects/${payload.projectId}/issues`;
      try {
        const issues = await axios.get(url, payload.paramData);
        commit('setProjectIssues', issues.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the project budgets list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchBudgetInstances ({ dispatch, commit }, payload) {
      const url = `api/devices/budgets/${payload.budgetId}/instances`;
      try {
        const instances = await axios.get(url);
        commit('setBudgetInstances', instances.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the budget instances list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchProjectContracts ({ dispatch, commit }, payload) {
      const url = `api/devices/projects/${payload.projectId}/contracts`;
      try {
        const contracts = await axios.get(url);
        commit('setProjectContracts', contracts.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the project contracts list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchOrganizationProjects ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.organizationExtId}/projects`;
      try {
        const projects = await axios.get(url);
        commit('setOrganizationProjects', projects.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the projects list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    selectedOrgProject ({ commit }, payload) {
      commit('setSelectedOrgProject', payload);
    },
    async fetchOrganizationProjectGates ({ dispatch, commit }, payload) {
      const url = `api/devices/projects/${payload.projectId}/project-gates`;
      try {
        const projectGates = await axios.get(url);
        commit('setOrganizationProjectGates', projectGates.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the project gates list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    selectedOrgProjectGate ({ commit }, payload) {
      commit('setSelectedOrgProjectGate', payload);
    },
    async fetchAppUserProjectActivity ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/projects/${payload.projectId}/activities`;
      try {
        const activities = await axios.get(url, payload.params);
        commit('setAppUserProjectActivities', activities.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the project activities.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchProjectGateDetails ({ dispatch, commit }, payload) {
      const url = `api/devices/project-gates/${payload.id}`;
      try {
        const response = await axios.get(url, payload.params);
        commit('setGateDetails', response.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the gate details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchProjectOrganization ({ dispatch, commit }, payload) {
      const url = `${backendUrl}/api/devices/project-gates/${payload.id}/register`;
      try {
        const response = await axiosPublic.get(url, payload.params);
        commit('setOrgDetails', response.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the organization.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchProjectCompanies ({ dispatch, commit }, payload) {
      const url = `${backendUrl}/api/devices/project-gates/${payload.id}/project-companies`;
      try {
        const response = await axiosPublic.get(url, payload.params);
        commit('setProjectCompanies', response.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the project companies.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    clearAppUserProjectActivities ({ commit }) {
      commit('clearAppUserProjectActivitiesData');
    },
    clearGateDetails ({ commit }) {
      commit('setGateDetails', {});
    },
  },
};
